import ActionTypes from '../actions/types';
import Cookie from 'js-cookie';

const initialState = {
    token: Cookie.get('token'),
    isAuthenticated: false,
    loading: true,
    user: null,
    sessionId: 0
}

const authReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch(type){
        case ActionTypes.LOGIN_REQUEST:
            Cookie.remove('token');
            return {
                ...state,
                token: null,
                user: null,
                isAuthenticated: false,
                loading: true,
                sessionId: state.sessionId + 1
            };
        case ActionTypes.LOGIN_SUCCESS: 
            Cookie.set('token', payload.token);
            return {
                ...state,
                isAuthenticated: false,
                loading: true,
                user: null,
                token: payload.token
            };
        case ActionTypes.AUTH_ERROR:
        case ActionTypes.LOGIN_FAIL:
        case ActionTypes.LOGOUT:
            Cookie.remove('token');
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                loading: false,
                user: null,
                sessionId: state.sessionId + 1
            };
        case ActionTypes.USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload.user
            };
        default: 
            return state;
    }
}

export default authReducer;